import * as THREE from "three";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";

//// MODULES
import { perlinBlob } from "./perlinBlob.js";
import { loadUVModel } from "./modelLoader.js";
import MeshTransmissionMaterial from "./transmissionMaterial.js";

//// ASSETS
import hdrPath from "../assets/enviroment/bubble_reflection_compressed.hdr";
import letteringTextureURL from "../assets/textures/ribbon.jpg";
import letteringModelPath from "../assets/models/lettering.glb";

export function loadAssets(renderer, scene, onAssetsLoaded) {
  const manager = new THREE.LoadingManager(); // Create LoadingManager

  const envMapLoader = new THREE.PMREMGenerator(renderer);
  const rgbeLoader = new RGBELoader(manager); // Attach manager to loader
  const textureLoader = new THREE.TextureLoader(manager); // Attach manager to texture loader

  // Load HDR environment map
  rgbeLoader.load(hdrPath, (hdrmap) => {
    const envmap = envMapLoader.fromCubemap(hdrmap);
    scene.environment = envmap.texture;
  });

  // Load texture
  textureLoader.load(letteringTextureURL, (letteringTexture) => {
    letteringTexture.wrapS = letteringTexture.wrapT = THREE.RepeatWrapping;
    letteringTexture.repeat.set(1, 1);

    //// MATERIALS
    const transmissionMaterial = new MeshTransmissionMaterial();

    //// 3D AND MODELS
    perlinBlob(scene, transmissionMaterial);

    // Load model and apply textures
    loadUVModel({
      scene: scene,
      childName: "lettering",
      modelPath: letteringModelPath,
      map: letteringTexture,
      isUVAnimated: true,
      position: { x: 0, y: 0.075, z: -0.75 },
    });
  });

  // Trigger this when all assets are fully loaded
  manager.onLoad = () => {
    if (onAssetsLoaded) {
      onAssetsLoaded();
    }
  };
}
